<template>
<div class="container wrap container--translate--words">

  <div class="userinfo--container flex-grow-1 sidebar-margin">
    <div class="userinfo--container__stats container align-items-center justify-content-center">
      <div class="userinfo--container__stats--bg">
        <div class="userinfo--container__stats--bg--2">

          <svg width="250" class="circular-chart" x="0px" y="0px" viewBox="0 0 36 36" xml:space="preserve">
            <path class="circle2" stroke-dasharray="55, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
            <path class="circle" :stroke-dasharray="`${parseInt((user.xp * 55) / getTotal(user.level))}, 100`" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
              <defs>
              <linearGradient id="MyGradient">
                <stop offset="50%" stop-color="#7F00FD" />
                <stop offset="100%" stop-color="#FFA200" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <div class="userinfo--container__box container column justify-content-center align-items-center">

      <div class="levelNumbers">
        <div id="" class="actualLevel">{{ parseInt(user.xp) }}</div>
        <div class="targetLevel">{{ getTotal(user.level) }}</div>
      </div>
      <div class="levelNumbers">
        <div id="" class="nowLevel">
          <span style="font-size: 11px; color: darkorange;">LEVEL&nbsp;</span>{{user.level}}</div>
        <div class="nextLevel">
          <span style="font-size: 11px; color: #981fff;">LEVEL&nbsp;</span>{{ user.level + 1 }}</div>
      </div>

      <div class="userinfo--stats animation-fade animation-delay-1">
        <img src="@/assets/img/personagens/bloogApprentice.png" alt="Minds">
      </div>


      <div class="userinfo--container__box--class container justify-content-center animation-fade animation-delay-1">
        <img src="@/assets/img/crown.svg" width="21" alt="Minds">
        <div class="class-name">
          <router-link to="/niveis">{{ getLevelName(user.level) }}</router-link>
        </div>
      </div>

      <div class="container experienceBox">
        <img src="@/assets/img/xp.svg" width="21" alt="Minds">
        <div id="xp">Experience<i style="margin: 0px 5px; font-size: 10px;"class="margin-left-5 fas fa-arrow-right"></i> <strong>{{ parseInt(xp) }}</strong></div>
      </div>

      <div class="container mdscoinsBox">
        <img src="@/assets/img/coin.svg" width="21" alt="Minds">
        <div id="coin">Mds Coins<i style="margin-left: 0px 5px; font-size: 10px;"class="margin-left-5 fas fa-arrow-right"></i> <strong>{{ score }}</strong></div>
      </div>

      <div class="userinfo--container__box--btn container justify-content-center animation-bottom animation-delay-1" v-if="!$store.getters['student/GET'].teens">
        <router-link :to="{ name: 'review' }" class="btn btn-md btn-red btn-full btn-rounded">
          PRACTICE <i class="margin-left-5 fas fa-arrow-right"></i>
        </router-link>
        <!-- <router-link :to="{ name: 'salaVirtual' }" class="btn btn-md btn-red btn-full btn-rounded">
          TRAINING ROOM <i class="margin-left-5 fas fa-arrow-right"></i>
        </router-link> -->
      </div>

    </div>
  </div>

</div>
</template>

<script>

export default {
  components: {
  },
  name: 'unidades',
  data () {
    return {
      totalPoints: 800
    }
  },
  props: {
    user: {
      type: Object
    }
  },
  methods: {
    getLevelName (level) {
      switch (level) {
        case 1:
          return 'Apprentice'
          break
        case 2:
          return 'Planner'
          break
        case 3:
          return 'Browser'
          break
        case 4:
          return 'Explorer'
          break
        case 5:
          return 'Colonizer'
          break
        case 6:
          return 'Knight'
          break
        case 7:
          return 'Grand Duke'
          break
        case 8:
          return 'Imperial Prince'
          break
        case 9:
          return 'Emperor'
          break
        default:
          return 'Apprentice'
      }
    },
    getTotal (level) {
      return parseInt(level) * 800
    }
  },
  computed: {
    xp () {
      return Math.trunc(parseFloat(this.$store.getters['student/GET'].xp))
    },
    score () {
      return Math.trunc(parseFloat(this.$store.getters['student/GET'].score))
    }
  }
}
</script>

<style lang="scss" scoped>
.arrow-way {
    background: #ccc;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 14px;
    opacity: 0.5;
    cursor: pointer;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    &.arrow-left {
        margin-right: 2px;
    }
    &.arrow-right {
        margin-left: 2px;
    }
    &:hover {
        opacity: 1;
    }
    svg {
      vertical-align: -0.250em;
    }
}
.userinfo--container__stats {
  z-index: 3;
  position: inherit;

    .userinfo--container__stats--bg {
        width: 230px;
        height: 100px;
        max-width: 90%;
        background: rgba(0,0,0, .1);
        border-radius: 100px 100px 0 0;
    }
    .userinfo--container__stats--bg--2 {
        width: 235px;
        height: 100px;
        max-width: 90%;
        background: #fff;
        border-radius: 100px 100px 0 0;
        margin: 0 auto;
        position: relative;
    }
}
.userinfo--stats {
    position: absolute;
    top: -54px;
    left: 0px;
    width: 100%;
    height: 140px;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 4;
    img{
      width: 100px;
      top: 2px;
      position: absolute;
    }
}
.percent--user {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.userinfo--container {
    position: relative;
    .userinfo--container__box {
        position: relative;
        margin-bottom: 20px;
        padding: 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 20px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 37px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);
        box-shadow: 10px 10px 37px 0 rgba(0, 0, 0, 0.19), 0 8px 8px 0 rgba(0, 0, 0, 0.09);

        .userinfo--container__box--class {
            width: 100%;
            padding-top: 68px;
            text-align: center;
            z-index: 5;
            .class-name {
              width: 100%;
              background: #efefef;
              height: 20px;
              // padding: 12px 0px;
              border-radius: 20px;
              font-size: 14px;
              font-weight: 300;
              letter-spacing: 2px;
              border: 1px solid gray;
              text-transform: uppercase;
              display: flex;
              display: -webkit-box;
              display: -ms-flexbox;
              align-items: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              justify-content: center;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              a{
                color: gray!important;
              }
            }
            img{
              margin: 0px 5px 0px 0px;
              height: 21px;

            }
        }
        .userinfo--container__box--btn {
            width: 100%;
            margin: 5px 0px;
          }
    }
}

.levelNumbers{
      position: absolute;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      /* height: 100%; */
      top: 0;
      justify-content: space-between;
      /* align-items: center; */
      z-index: 3;

  .actualLevel{
    flex-basis: 30px;
    max-width: 70px;
    margin: 20px 0px;
    border-radius: 00px 30px 30px 0px;
    border-left-width: 0px!important;
    height: 23px;
    background: white;
    border: 1px solid #981fff;
    color: #981fff;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .targetLevel{
    flex-basis: 30px;
    max-width: 70px;
    margin: 20px 0px;
    border-radius: 30px 00px 00px 30px;
    border-right-width: 0px!important;
    height: 23px;
    background: white;
    border: 1px solid darkorange;
    color: darkorange;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .nowLevel{
    flex-basis: 30px;
    max-width: 70px;
    margin: 48px 0px;
    border-radius: 00px 30px 30px 0px;
    border-left-width: 0px!important;
    height: 23px;
    background: white;
    border: 1px solid #42007a;
    color: #8609f0;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .nextLevel{
    flex-basis: 30px;
    max-width: 70px;
    margin: 48px 0px;
    border-radius: 30px 00px 00px 30px;
    border-right-width: 0px!important;
    height: 23px;
    // background: orange;
    border: 1px solid darkorange;
    color: darkorange;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }
}

.experienceBox{
margin: 5px 0px 5px 0px;
justify-content: center;
align-items: center;
flex-grow: 1;
width: 100%;

img{
  margin: 0px 5px 0px 0px;
}

#xp{
  padding: 2px 9px;
  font-weight: 200;
  font-size: 15px;
  text-align: center;
  color: #525252;
  border: 1px solid gray;
  border-radius: 300px;
  width: 100%;
  // display: table;
}

}
.mdscoinsBox{
margin: 0px 0px 5px 0px;
justify-content: center;
align-items: center;
flex-grow: 1;
width: 100%;

img{
  margin: 0px 5px 0px 0px;
}

#coin{
  padding: 2px 9px;
  font-weight: 200;
  background: #ffcb00;
  color: #624900;
  font-size: 15px;
  text-align: center;
  border: 1px solid #866e0d;
  border-radius: 300px;
  width: 100%;
  // display: table;
}
}
</style>



// WEBPACK FOOTER //
// src/components/userProperties/index.vue